/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown>, unit: NonNullable<unknown>, period: NonNullable<unknown> }} Signup_Compare_AllowanceInputs */

const en_signup_compare_allowance = /** @type {(inputs: Signup_Compare_AllowanceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.amount} ${i?.unit}/${i?.period}`)
};

const fr_signup_compare_allowance = /** @type {(inputs: Signup_Compare_AllowanceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.amount} ${i?.unit}/${i?.period}`)
};

const de_signup_compare_allowance = /** @type {(inputs: Signup_Compare_AllowanceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.amount} ${i?.unit}/${i?.period}`)
};

const it_signup_compare_allowance = /** @type {(inputs: Signup_Compare_AllowanceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.amount} ${i?.unit}/${i?.period}`)
};

const ru_signup_compare_allowance = /** @type {(inputs: Signup_Compare_AllowanceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.amount} ${i?.unit}/${i?.period}`)
};

const es_signup_compare_allowance = /** @type {(inputs: Signup_Compare_AllowanceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.amount} ${i?.unit}/${i?.period}`)
};

const zh_cn2_signup_compare_allowance = /** @type {(inputs: Signup_Compare_AllowanceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.amount} ${i?.unit}/${i?.period}`)
};

const ja_signup_compare_allowance = /** @type {(inputs: Signup_Compare_AllowanceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.amount} ${i?.unit}/${i?.period}`)
};

const hi_signup_compare_allowance = /** @type {(inputs: Signup_Compare_AllowanceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.amount} ${i?.unit}/${i?.period}`)
};

const pt_pt2_signup_compare_allowance = /** @type {(inputs: Signup_Compare_AllowanceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.amount} ${i?.unit}/${i?.period}`)
};

/**
* | output |
* | --- |
* | "{amount} {unit}/{period}" |
*
* @param {Signup_Compare_AllowanceInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_allowance = /** @type {((inputs: Signup_Compare_AllowanceInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_AllowanceInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_compare_allowance(inputs)
	if (locale === "de") return de_signup_compare_allowance(inputs)
	if (locale === "it") return it_signup_compare_allowance(inputs)
	if (locale === "ru") return ru_signup_compare_allowance(inputs)
	if (locale === "es") return es_signup_compare_allowance(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_compare_allowance(inputs)
	if (locale === "ja") return ja_signup_compare_allowance(inputs)
	if (locale === "hi") return hi_signup_compare_allowance(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_compare_allowance(inputs)
	return en_signup_compare_allowance(inputs)
});